import React from 'react';

const THRESHOLD = 80;

function PullToRefreshIndicator({ pullDistance, isRefreshing }) {
  if (pullDistance <= 0 && !isRefreshing) return null;

  const progress = Math.min(pullDistance / THRESHOLD, 1);
  const rotation = pullDistance >= THRESHOLD ? 180 : progress * 180;

  return (
    <div
      className="ptr-indicator"
      style={{
        transform: `translateY(${Math.min(pullDistance, THRESHOLD + 20)}px)`,
        opacity: Math.max(progress, isRefreshing ? 1 : 0),
      }}
    >
      <div className={`ptr-spinner ${isRefreshing ? 'spinning' : ''}`}>
        {isRefreshing ? (
          <span className="ptr-loading">&#8635;</span>
        ) : (
          <span
            className="ptr-arrow"
            style={{ transform: `rotate(${rotation}deg)` }}
          >
            &#8595;
          </span>
        )}
      </div>
    </div>
  );
}

export default PullToRefreshIndicator;
